import {tns} from "../../../node_modules/tiny-slider/src/tiny-slider";
import Plyr from 'plyr';
import Typed from 'typed.js';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

if (document.querySelector('.home__slider')) {
    var slider = tns({
        container: '.home__slider-container',
        items: 1,
        mode: 'gallery',
        controls: false,
        nav: false,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayButtonOutput: false,
        arrowKeys: true,
        speed: 800,
        mouseDrag: false,
        lazyload: true,
        lazyloadSelector: '.home__slider-image',
    });
}

if (document.querySelectorAll('.page-overlay').length > 0) {
    let overlays = document.querySelectorAll('.page-overlay');
    let overlayClose = document.querySelectorAll('.overlay__close');

    overlays.forEach(function (overlay) {
        overlay.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector('#' + overlay.dataset.overlay).classList.toggle('overlay--open');
        });
    });

    overlayClose.forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            button.parentElement.classList.remove('overlay--open');
        });
    });
}

// window.onload = function () {
//     document.querySelector('body').classList.add('loaded');
// };

document.addEventListener("DOMContentLoaded", function() {
    document.body.classList.add('loaded');
}, false);

window.onpageshow = function(event) {
    if (event.persisted) {
        document.body.classList.add('loaded');
    }
}

if (document.querySelectorAll('a[href^="http"]:not(.home__cta)').length > 0) {
    document.querySelectorAll('a[href^="http"]:not(.home__cta)').forEach(function (a) {
        if(a.getAttribute('target') && a.getAttribute('target') !== '_blank') {
            a.addEventListener('click', function (e) {
                e.preventDefault();

                document.querySelector('body').classList.remove('loaded');
                setTimeout(function () {
                    window.location = a.href;
                }, 600);
            });
        }
    });
}

if (document.querySelectorAll('.js-player').length > 0) {
    const players = Array.from(document.querySelectorAll('.js-player')).map(p => new Plyr(p, {
        settings: ['quality', 'speed'],
    }));
}

if (document.querySelector('#typed')) {
    var typed = new Typed('#typed', {
        stringsElement: '#typed-strings',
        loop: true,
        showCursor: false,
        typeSpeed: 15,
        backSpeed: 10,
        backDelay: 3000,
    });
}

// function loadResponsive() {
//     console.log(window.innerWidth);
// }
//
// window.addEventListener('resize', loadResponsive);

if (document.querySelector('.header')) {
    const header = document.querySelector('.header');

    if (window.innerWidth >= 768) {
        window.addEventListener('scroll', function () {
            if (window.pageYOffset > (header.offsetTop + header.offsetHeight)) {
                header.classList.add('header--compact');
            } else {
                header.classList.remove('header--compact');
            }
        });
    }
}

if (window.innerWidth < 768) {
    if (document.querySelector('.two-sections > .container')) {
        $('.two-sections > .container').slick({
            adaptiveHeight: true,
            dots: true,
            infinite: false,
        });

        $('.two-sections > .container').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            console.log(this);
            $('html, body').animate({ scrollTop: $(this).offset().top - 85}, 350);
        });
    }
}

if (document.querySelector('.section-nav')) {
    const sectionNav = document.querySelector('.section-nav');

    fixedSectionNav();
    window.addEventListener('scroll', fixedSectionNav);

    function fixedSectionNav () {
        if ((window.pageYOffset + window.innerHeight) < (sectionNav.offsetTop + sectionNav.offsetHeight)) {
            sectionNav.classList.add('section-nav--fixed');
        } else {
            sectionNav.classList.remove('section-nav--fixed');
        }
    }
}

if (document.querySelector('.main--product')) {
    let mouseTarget;

    document.body.addEventListener('mousemove', (e) => {
        mouseTarget = e.target;
    });

    function horizontalScroll (e) {
        if(mouseTarget.closest('.news-single__description') === null) {
            if(e.wheelDelta) {
                this.scrollLeft -= (e.wheelDelta);
            }
            else {
                this.scrollLeft += (e.deltaY * 30);
            }

            e.preventDefault();
        }
    }

    if (window.innerWidth >= 768) {
        document.querySelector('.main--product').addEventListener('wheel', horizontalScroll);
    }
}

document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(function(item){
    item.addEventListener('click', function (e) {
        e.preventDefault();
        let path = this.getAttribute('href').replace(/^\/+/, '').replace(/^#+/, '');

        if(document.querySelector('*[id="'+ path +'"]')) {
            document.querySelector('*[id="'+ path +'"]').scrollIntoView({behavior: 'smooth'});
        }
        else {
            window.location = this.href;
        }
    });
});

jQuery(document).on('gform_post_render', function(){
    document.querySelector('.gform_footer .gform_button').addEventListener('click', function() {
        this.classList.add('form--submitted');
    });
});
